module.exports = __webpack_public_path__ + "media/images/home-page-video-banner-e0c91edc.jpg";